exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"colors.css","sourceRoot":""}]);

// exports
exports.locals = {
	"green50": "#408700",
	"green100": "#53a642",
	"green150": "#58bd44",
	"green200": "#a6cf9d",
	"greenL250": "#ecf3e5",
	"green250": "#3f8700",
	"red50": "#f8672f",
	"red100": "#e64545",
	"red150": "#f2a2a2",
	"redL200": "#fce5da",
	"red200": "#e95723",
	"orange50": "#ea5724",
	"orange100": "#ef7c46",
	"white50": "#fff",
	"white100": "#f0f2f4",
	"black50": "#222222",
	"black100": "#494949",
	"black150": "#242526",
	"silver50": "#f6f6f6",
	"silver100": "#3a3b3c",
	"silver150": "#999999",
	"lilac50": "rgb(112, 135, 204)",
	"lilac100": "rgb(126, 152, 229)"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--0-1!./node_modules/postcss-loader/lib!./src/styles/colors.css
// module id = 0
// module chunks = 3